module.exports = __webpack_public_path__ + "tables/media/Email_filled.84c20c1d.svg";